import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import type { SelfDescribingJson } from '@snowplow/browser-tracker'

export type CheckoutObservabilityModule =
  | 'walled_garden'
  | 'room_upgrade'
  | 'lux_plus'
  | 'flights'
  | 'baggage'
  | 'experiences'
  | 'one_click_transfer'
  | 'cfmr'
  | 'travel_protection'
  | 'car_hire'
  | 'payment_schedule'
  | 'loyalty'
  | 'credits'
  | 'merchandise_shipping'

export type CheckoutObservabilityReasonCode =
  | 'traveller_schema_not_ready'
  | 'page_validation_failed'
  | 'native_form_invalid'
  | 'velocity_sso_token_expired'
  | 'payment_declined'
  | 'payment_authentication_failed'
  | 'payment_cancelled'
  | 'payment_method_not_selected'
  | 'duplicate_transaction'
  | 'network_error'
  | 'order_payload_not_ready'
  | 'order_creation_failed'
  | 'gift_receiver_same_as_giver'
  | 'flight_commission_not_set'
  | 'no_flights_available'
  | 'flight_session_expired'
  | 'flight_reprice_failed'
  | 'no_inventory'
  | 'funnel_feature_disabled'
  | 'fraud_short_lead_time_high_risk_flight'
  | 'fraud_high_risk_flight_route'
  | 'insufficient_loyalty_points'
  | 'insufficient_loyalty_benefit'
  | 'loyalty_points_price_changed'
  | 'load_timeout'
  | 'unknown'

export type CheckoutObservabilityState =
  | 'content_visible'
  | 'interaction_ready'
  | 'continuation_ready'
  | 'empty'
  | 'degraded'
  | 'blocked'
  | 'selected'
  | 'declined'
  | 'selection_invalidated'
  | 'submit_clicked'
  | 'authorisation_started'
  | 'authorisation_result'
  | 'creation_started'
  | 'creation_result'
  | 'validation_failed'

export interface CheckoutObservabilityContextData extends Omit<comluxgroup.CheckoutObservability_1_0_0, 'state' | 'module' | 'scope' | 'reasonCode' | 'exitDestination'> {
  state: CheckoutObservabilityState
  module?: CheckoutObservabilityModule | null
  scope?: 'cart' | 'item' | null
  reasonCode?: CheckoutObservabilityReasonCode | null
  isBlocking?: boolean
  canContinue?: boolean
  optionCount?: number
  timeToContentVisibleMs?: number
  dependencyDurationMs?: number
  paymentAttemptSequence?: number
  exitDestination?: 'cart' | 'home' | 'search' | 'offer' | 'account' | 'external' | 'other' | null
}

export function checkoutObservabilityContext(data: CheckoutObservabilityContextData): SelfDescribingJson {
  return comluxgroup.createCheckoutObservability_1_0_0(data)
}
